import * as Sentry from "@sentry/browser";

export const SENTRY_DSN = import.meta.env.SENTRY_DSN_BROWSER;

// Pure module: nothing runs on import. The entry point calls initSentry() as its
// first statement, so Sentry's global handlers are installed before any other
// work — even a crash during later init is then reported. See docs/KNOWN_ISSUES.md.
export function initSentry(): void {
  if (!SENTRY_DSN) {
    return;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: import.meta.env.SENTRY_ENVIRONMENT || 'production',
    release: import.meta.env.SENTRY_RELEASE,
    sendDefaultPii: true,
    tracesSampleRate: 1.0,
  });
}
